/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoSolicitacoesRoutes {
  ALTERACAO_VINCULO_ROUTE = '/alteracao-vinculo',
  COMPARTILHAR_RISCO_ROUTE = '/compartilhamento-risco',
  CONSULTAR_ALTERACAO_CADASTRAL_HISTORICO_ROUTE = '/:nrSeqSolicAlt/pessoas/:cdPessoaFisica',
  CONSULTAR_ALTERACAO_CADASTRAL_ROUTE = '/alteracao-cadastral',
  CONSULTAR_ALTERACAO_DATA_ADMISSAO = '/alteracao-data-admissao',
  CONSULTAR_ALTERACAO_LOCALIZACAO_ROUTE = '/alteracao-localizacao',
  CONSULTAR_ALTERACAO_MATRICULA = '/alteracao-matricula',
  CONSULTAR_ALTERACAO_PRODUTO_ROUTE = '/alteracao-produto',
  CONSULTAR_ALTERACAO_SUBESTIPULANTE_ROUTE = '/alteracao-subestipulante',
  CONSULTAR_INCLUSOES_BENEFICIARIO_ROUTE = '/inclusao-beneficiario',
  CONSULTAR_MIGRACAO_CONTRATO_ROUTE = '/migracao-contrato',
  CONSULTAR_STATUS_VIA_ROUTE = '/segunda-via',
  CONSULTAR_TRANSFERENCIA_TITULARIDADE = '/transferencia-titularidade',
}
export { HistoricoSolicitacoesRoutes };
